// ** Custom Components
import Text from "components/typography/Text";
import Block from "components/layout/Block";
import DatePresenter from "components/other/DatePresenter";

// #####################################################

const NextDay = ({ date }) => {
	return (
		<Block flex justifyCenter alignCenter pt={2} mb={2}>
			<Text small color="grey">
				<DatePresenter dateOnly date={date} />
			</Text>
		</Block>
	);
};

// ####################################################

export default NextDay;

// ####################################################
